{
  "s_light": "clair",
  "s_dark": "sombre",
  "nav_explore": "Explorer Zurich",
  "nav_explore_desc": "Restaurants, hôtels, activités à Zurich et ses environs, et plus encore.",
  "nav_home": "inzh.ch",
  "nav_home_desc": "Portail d'information pour Zurich et ses environs",
  "nav_kantonsrat": "Conseil d'État",
  "nav_kantonsrat_desc": "Personnes, séances et organes du Conseil d'État de Zurich",
  "nav_about": "À propos",
  "nav_about_desc": "À propos d'inzh.ch, politique de confidentialité et mentions légales",
  "l_expand": "Vue complète",
  "l_collapse": "Fermer la vue complète",
  "l_back": "Retour",
  "l_asceding": "Ascendant",
  "l_descending": "Descendant",
  "l_privacy": "Confidentialité",
  "l_privacy_txt": "inzh.ch stocke un cookie pour enregistrer la préférence de thème. Les sources de la carte interactive et des images tentent également de définir des cookies tiers.",
  "l_impressum": "Mentions légales",
  "l_page_not_found": "Page introuvable / 404",
  "nav_news": "Actualités et communications",
  "nav_news_desc": "Actualités et informations générales de Zurich et au-delà"
}